var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-display"},[(_vm.logoSrc)?_c('img',{attrs:{"src":_vm.logoSrc,"alt":"Provider Logo"}}):_c('img',{staticClass:"logo-default",attrs:{"src":require("@Shared/assets/images/default-provider-logo.svg"),"alt":"Provider Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }